export const activeMediaOutlet = $state({ value: 'all' });

export const dateExtent = $state([]);

export const thresholdTexture = $state({ value: null });
